import { render, staticRenderFns } from "./PopinError.vue?vue&type=template&id=497afc8f&"
import script from "./PopinError.vue?vue&type=script&lang=js&"
export * from "./PopinError.vue?vue&type=script&lang=js&"
import style0 from "./PopinError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports